import { errorMessage } from "@lumora/bridge";
import { useState, type ReactNode } from "react";

export type ActionStatus = { msg: string | null; err: string | null };

/** msg/err status for a provisioning action: start() clears, ok(msg) / fail(err, fallback) set. */
export function useActionStatus() {
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  return {
    msg,
    err,
    start: () => {
      setMsg(null);
      setErr(null);
    },
    ok: (m: string) => setMsg(m),
    fail: (e: unknown, fallback: string) => setErr(errorMessage(e, fallback)),
  };
}

/** Shared shell for the platform provisioning panels (owner, payment, Connect). */
export function ProvisionCard({
  title,
  lead,
  status,
  children,
  ...rest
}: {
  title: string;
  lead: ReactNode;
  status: ActionStatus;
  children: ReactNode;
} & Record<`data-${string}`, string | boolean | undefined>) {
  return (
    <section className="ops-panel platform-provision-card" {...rest}>
      <h3>{title}</h3>
      <p className="muted">{lead}</p>
      {children}
      {status.msg ? (
        <p className="muted platform-provision-status" role="status" aria-live="polite">
          {status.msg}
        </p>
      ) : null}
      {status.err ? (
        <p className="ops-error platform-provision-status" role="alert">
          {status.err}
        </p>
      ) : null}
    </section>
  );
}
